// Session storage for the signed-in user. sessionStorage keeps the session per tab; if
// storage is blocked (private mode, strict settings) the values live in memory instead.
const TOKEN_KEY  = 'sot_token';
const USER_KEY   = 'sot_user';
const LEGACY_KEY = 'sot_unlocked'; // old PIN flag, removed on sign-in and sign-out

let memToken = null;
let memUser  = null;

const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* memory copy still holds it */ } };
const remove = (key) => { try { sessionStorage.removeItem(key); } catch { /* ignore */ } };

export function getToken() {
  return read(TOKEN_KEY) || memToken;
}

export function getUser() {
  const raw = read(USER_KEY);
  if (raw) {
    try { return JSON.parse(raw); } catch { /* fall through to memory copy */ }
  }
  return memUser;
}

// user is optional so a refreshed token can be stored without touching the saved user.
export function setSession({ token, user }) {
  memToken = token;
  write(TOKEN_KEY, token);
  if (user) {
    memUser = user;
    write(USER_KEY, JSON.stringify(user));
  }
  remove(LEGACY_KEY);
}

export function clearSession() {
  memToken = null;
  memUser  = null;
  remove(TOKEN_KEY);
  remove(USER_KEY);
  remove(LEGACY_KEY);
}
